<template lang="pug">
div
    .table-container(v-for="(variant, variant_index) in variants", :key="variant.id")
        table.table.borderless.table-sm
            thead
                tr
                    th.text-nowrap._500(v-show="product.use_variant") Variant
                    th.text-nowrap._500 Component
                    th.text-nowrap._500 Portion
                    th
            tbody
                //- if no composite
                tr(v-show="!variant.stock.composites.length")
                    td.p-a {{ variant.name }}
                    td.p-a.text-center(colspan="3")
                        i.text-muted No component added

                tr(v-for="(composite, composite_index) in variant.stock.composites", :key="composite.id")
                    td(
                        :rowspan="variant.stock.composites.length || 1"
                        v-show="product.use_variant",
                        v-if="composite_index < 1"
                    )
                        span {{ variant.name }}

                    td {{ composite.composite_stock.name }}
                    td.w-md
                        input.w-sm.form-control(
                            :class="{ 'has-error': errors.has('potion', `potion_${product.id}_${variant.id}_${composite.id}`) }",
                            name="potion",
                            type="text",
                            :value="composite.composite_potion",
                            :key="`potion_${product.id}_${variant.id}_${composite.id}`",
                            :data-vv-scope="`potion_${product.id}_${variant.id}_${composite.id}`",
                            v-validate="'required|decimal:2|min_value:0.01'",
                            @input="updateComponent(variant_index, composite_index, 'composite_potion', $event.target.value)",
                            placeholder="0.00",
                        )
                        span.text-danger(v-if="errors.has('potion', `potion_${product.id}_${variant.id}_${composite.id}`)")
                            | {{ errors.first('potion', `potion_${product.id}_${variant.id}_${composite.id}`) }}

                    td.text-muted.w-xs.text-right
                        button.md-btn.md-flat.m-b-sm.btn-xs(
                            @click="removeComponent(variant_index, composite_index)"
                        )
                            i.material-icons delete
                tr
                    td.p-t-sm.p-b-md(colspan="4")
                        .pull-right.w-400
                            stock-selector(
                                @select="onSelectStock",
                                placeholder="Select Component",
                                :exclude-ids="excludeIds(variant.stock.composites)",
                                :id="String(variant_index)"
                            )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    inject: ['$validator'],

    computed: {
        ...mapGetters('product', ['variants', 'product']),
    },

    methods: {
        ...mapActions('product', [
            'addCompositeComponent',
            'removeCompositeComponent',
            'updateCompositeComponent',
        ]),

        onSelectStock(stock, variant_index) {
            const payload = {
                variant_index,
                composite_stock: stock,
                composite_stock_id: stock.id,
                composite_potion: null,
            };

            this.addCompositeComponent(payload);
        },

        excludeIds(composites) {
            const selfIds = this.variants.map(v => v.stock.id);

            const ids = composites.map(
                composite => composite.composite_stock_id,
            );

            return selfIds.concat(ids);
        },

        removeComponent(variant_index, index) {
            const composite = this.variants[variant_index].stock.composites[
                index
            ];

            if (composite.id > 0) {
                swal({
                    text: 'Delete component from composite item ?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dc3545',
                    cancelButtonColor: '#fff',
                    cancelButtonClass: 'text-dark',
                    confirmButtonText: 'Yes, delete it!',
                }).then(result => {
                    if (result) {
                        this.removeCompositeComponent({ variant_index, index });
                    }
                });
            } else {
                this.removeCompositeComponent({ variant_index, index });
            }
        },

        updateComponent(variant_index, index, key, value) {
            this.updateCompositeComponent({ variant_index, index, key, value });
        },
    },
};
</script>

<style lang="scss" scoped>
.w-400 {
    width: 400px;
}

.table-container {
    @media screen and (max-width: 766px) {
        overflow-x: auto;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/product/product-stock-composite.vue